import { render, staticRenderFns } from "./CaskPredplatneList.vue?vue&type=template&id=4a1a0cba&"
import script from "./CaskPredplatneList.vue?vue&type=script&lang=ts&"
export * from "./CaskPredplatneList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports